// Letter, number, space, underscore and hyphen are allowed in name input field. All other characters will be removed.
export const sanitizeNameInput = (value = "") =>
  value.replace(/[^A-Za-z0-9 _-]/g, "");

// Letter, number, underscore and hyphen are allowed in key input field. All other characters and spaces will be removed.
export const sanitizeKeyInput = (value = "") =>
  value.replace(/[^A-Za-z0-9_-]/g, "");

// Only positive numbers are allowed in the input field. All other characters will be removed.
export const sanitizePositiveNumberInput = (value = "") =>
  value.replace(/[^0-9]/g, "");